function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable max-lines */
/* eslint-disable react/no-multi-comp */
import React, { useEffect, useMemo, useRef, useState } from 'react';

import { Icon } from "../UI";

import { connect } from 'react-redux';
import { I18NLink, Translate } from "../I18N";
import { socket } from "../socket";
import { store } from "../store";

import { Pagination } from "../UI/BasicTable/Pagination";
import { RequestParams } from "../utils/RequestParams";
import { SuggestionAcceptanceModal } from "./SuggestionAcceptanceModal";
import { notify } from "../Notifications/actions/notificationsActions";
import { suggestionsTable } from "./SuggestionsTable";
import { objectIndex } from "../../shared/data_utils/objectIndex";



import { SuggestionState } from "../../shared/types/suggestionSchema";



import {
  getStats,
  getSuggestions,
  ixStatus,
  trainModel,
  cancelFindingSuggestions } from "./SuggestionsAPI";

import { PDFSidePanel } from "./PDFSidePanel";
import { TrainingHealthDashboard } from "./TrainingHealthDashboard";
import { CancelFindingSuggestionModal } from "./CancelFindingSuggestionsModal";
import { FiltersSidePanel } from "./FilterSidePanel";














function mapStateToProps({ templates }) {
  return {
    templates
  };
}

const getTemplateMap = (templates) => {
  const templateNamesById = objectIndex(
    templates.toJS(),
    (t) => {var _t$_id;return ((_t$_id = t._id) === null || _t$_id === void 0 ? void 0 : _t$_id.toString()) || '';},
    (t) => t.name
  );
  return templateNamesById;
};

// eslint-disable-next-line max-statements
const EntitySuggestionsComponent = ({
  property: reviewedProperty,
  acceptIXSuggestion,
  templates,
  languages,
  extractor
}) => {
  const isMounted = useRef(false);
  const [suggestions, setSuggestions] = useState([]);
  const [aggregations, setAggregations] = useState({
    state: [],
    template: []
  });
  const [totalPages, setTotalPages] = useState(0);
  const [resetActivePage, setResetActivePage] = useState(false);
  const [status, setStatus] = useState({
    key: 'ready'
  });
  const [acceptingSuggestion, setAcceptingSuggestion] = useState(false);
  const [openCancelFindingSuggestions, setOpenCancelFindingSuggestions] = useState(false);
  const [sidePanelOpened, setSidePanelOpened] = useState(false);
  const [stats, setStats] = useState(undefined);

  const [filtersOpen, setFiltersOpen] = useState(false);

  const templateNamesById = useMemo(() => getTemplateMap(templates), [templates]);
  const [templateSelection, setTemplateSelection] = useState([]);
  const [sueggestionStateSelection, setSuggestionStateSelection] = useState([]);

  const showConfirmationModal = (row) => {
    row.toggleRowSelected();
    setAcceptingSuggestion(true);
  };

  const actionsCellButtonClassNames = (state) => {
    let className = 'btn';
    if (state === SuggestionState.labelMatch) {
      className += 'btn-outline-success label-match';
    }
    if (state === SuggestionState.labelMismatch || state === SuggestionState.valueMismatch) {
      className += 'btn-outline-warning label-value-mismatch';
    }

    if (state === SuggestionState.valueMatch) {
      className += 'btn-outline-primary value-match';
    }
    if (
    state === SuggestionState.labelEmpty ||
    state === SuggestionState.valueEmpty ||
    state === SuggestionState.obsolete ||
    state === SuggestionState.empty ||
    state === SuggestionState.error)
    {
      className += 'btn-outline-secondary disabled';
    }

    return className;
  };

  const isRequiredFieldWithoutSuggestion = (row) =>
  row.propertyName === 'title' && row.suggestedValue === '' ||
  reviewedProperty.required && row.suggestedValue === '';

  const actionsCell = ({ row }) => {
    const suggestion = row.values;
    const { state } = suggestion;
    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        "aria-label": "Accept suggestion",
        className: actionsCellButtonClassNames(state),
        disabled:
        state === SuggestionState.labelEmpty ||
        state === SuggestionState.valueEmpty ||
        state === SuggestionState.obsolete ||
        state === SuggestionState.labelMatch ||
        state === SuggestionState.error ||
        isRequiredFieldWithoutSuggestion(row.original),

        onClick: async () => showConfirmationModal(row) }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "arrow-right" })
      )
      ));

  };

  const showPDF = (row) => {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    toggleAllRowsSelected(false);
    row.toggleRowSelected();
    setSidePanelOpened(true);
  };

  const closePDFSidePanel = () => {
    setSidePanelOpened(false);
  };

  const segmentCell = ({ row }) => /*#__PURE__*/
  _jsx("div", { onClick: () => showPDF(row) }, void 0, /*#__PURE__*/
  _jsx("span", { className: "segment-pdf" }, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "Open PDF")
  ), /*#__PURE__*/
  _jsx("span", { className: "segment-context" }, void 0, row.original.segment)
  );


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    gotoPage,
    setPageSize,
    selectedFlatRows,
    toggleAllRowsSelected,
    state: { pageIndex, pageSize, filters }
  } = suggestionsTable(reviewedProperty, suggestions, totalPages, actionsCell, segmentCell);

  const retrieveSuggestions = (
  pageNumber = pageIndex + 1,
  _stateSelection = [],
  _templateSelection = []) =>
  {
    const filter =



    { extractorId: extractor._id };
    if (_stateSelection.length > 0) filter.states = _stateSelection;
    if (_templateSelection.length > 0) filter.entityTemplates = _templateSelection;
    const params = new RequestParams({
      page: { number: pageNumber, size: pageSize },
      filter
    });
    getSuggestions(params).
    then((response) => {
      setSuggestions(response.suggestions);
      setAggregations(response.aggregations);
      setTotalPages(response.totalPages);
    }).
    catch(() => {});
  };

  const retriveStats = () => {
    const params = new RequestParams({
      extractorId: extractor._id
    });
    getStats(params).
    then((response) => {
      setStats(response);
    }).
    catch(() => {});
  };

  const acceptSuggestion = async (allLanguages) => {
    if (selectedFlatRows.length > 0) {
      const acceptedSuggestion = selectedFlatRows[0].original;
      await acceptIXSuggestion(acceptedSuggestion, allLanguages);
      await retrieveSuggestions();
    }

    setAcceptingSuggestion(false);
    toggleAllRowsSelected(false);
    retriveStats();
  };

  const errorIsNoLabeledData = () => status.key === 'error' && status.message === 'No labeled data';

  const updateError = (changedPropertyValue) => {
    if (errorIsNoLabeledData() && changedPropertyValue && changedPropertyValue.length > 0) {
      setStatus({ key: 'ready' });
    }
  };

  const handlePDFSidePanelSave = async (entity) => {var _entity$metadata;
    setSidePanelOpened(false);
    const propertyName = reviewedProperty.name;
    const changedPropertyValue = entity[propertyName] || ((_entity$metadata =
    entity.metadata) === null || _entity$metadata === void 0 ? void 0 : _entity$metadata[propertyName]);
    await retrieveSuggestions();

    selectedFlatRows[0].setState({});
    updateError(changedPropertyValue);
    retriveStats();
  };

  const _trainModel = async () => {
    setStatus({ key: 'sending_labeled_data' });
    const params = new RequestParams({
      extractorId: extractor._id
    });

    const response = await trainModel(params);
    const type = response.status === 'error' ? 'danger' : 'success';
    setStatus({ key: response.status, data: response.data, message: response.message });
    store === null || store === void 0 ? void 0 : store.dispatch(notify(response.message, type));
    if (status.key === 'ready') {
      await retrieveSuggestions();
    }
  };

  const _cancelFindingSuggestions = async () => {
    setOpenCancelFindingSuggestions(false);
    const params = new RequestParams({
      extractorId: extractor._id
    });

    if (status.key !== 'ready') {
      setStatus({ key: 'cancel' });
      await cancelFindingSuggestions(params);
    }
  };

  const onFindSuggestionButtonClicked = async () => {
    if (status.key === 'ready') {
      setStatus({ key: 'sending_labeled_data' });
      await _trainModel();
    } else if (errorIsNoLabeledData()) {
      setStatus({ key: 'ready' });
    } else {
      setOpenCancelFindingSuggestions(true);
    }
  };

  const onStateSelectionChange = (values) => {
    setSuggestionStateSelection(values);
    retrieveSuggestions(pageIndex + 1, values, templateSelection);
  };

  const onTemplateSelectionChange = (values) => {
    setTemplateSelection(values);
    retrieveSuggestions(pageIndex + 1, sueggestionStateSelection, values);
  };

  const resetStateAndTemplateSelections = () => {
    setTemplateSelection([]);
    setSuggestionStateSelection([]);
    retrieveSuggestions(pageIndex + 1, [], []);
  };

  useEffect(retrieveSuggestions, [pageIndex, pageSize, filters]);
  useEffect(() => {
    if (isMounted.current) {
      retrieveSuggestions(1);
      gotoPage(0);
      setResetActivePage(true);
    } else {
      isMounted.current = true;
    }
  }, [filters]);
  useEffect(() => {
    const params = new RequestParams({
      extractorId: extractor._id
    });
    ixStatus(params).
    then((response) => {
      setStatus({ key: response.status, data: response.data, message: response.message });
    }).
    catch(() => {
      setStatus({ key: 'error' });
    });

    socket.on(
      'ix_model_status',
      (extractorId, modelStatus, _, data) => {
        if (extractorId === extractor._id) {
          setStatus({ key: modelStatus, data });
          if (data && data.total === data.processed || modelStatus === 'ready') {
            setStatus({ key: 'ready' });
            retrieveSuggestions();
          }
          retriveStats();
        }
      }
    );

    retriveStats();

    return () => {
      socket.off('ix_model_status');
    };
  }, []);

  const ixmessages = {
    ready: 'Find suggestions',
    sending_labeled_data: 'Sending labeled data...',
    processing_model: 'Training model...',
    processing_suggestions: 'Finding suggestions',
    cancel: 'Canceling...',
    error: 'Error'
  };

  const formatData = (data) =>
  data ? `${data.processed}/${data.total}` : '';

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("div", { className: "panel entity-suggestions" }, void 0, /*#__PURE__*/
    _jsx(FiltersSidePanel, {
      open: filtersOpen,
      reset: () => {
        resetStateAndTemplateSelections();
      },
      hideFilters: () => {
        setFiltersOpen(false);
      },
      templates: {
        options: aggregations.template.map(({ _id, count }) => ({
          key: _id,
          label: templateNamesById[_id],
          results: count
        })),
        selected: templateSelection,
        setSelection: onTemplateSelectionChange
      },
      states: {
        options: aggregations.state.map(({ _id, count }) => ({
          key: _id,
          label: _id,
          results: count
        })),
        selected: sueggestionStateSelection,
        setSelection: onStateSelectionChange
      } }
    ), /*#__PURE__*/
    _jsx("div", { className: "dashboard-link" }, void 0, /*#__PURE__*/
    _jsx(I18NLink, { to: "settings/metadata_extraction" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "arrow-left" }), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Back to dashboard")
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "panel-subheading" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "property-info-container" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "property-info-heading" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "suggestion-header" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Reviewing"), ":\xA0"
    ), /*#__PURE__*/
    _jsx("span", { className: "suggestion-property" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, reviewedProperty.label)
    ), /*#__PURE__*/
    _jsx("span", { className: "suggestion-for-label" }, void 0, "\xA0 ", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "for"), " \xA0"
    ), /*#__PURE__*/
    _jsx("span", { className: "suggestion-templates" }, void 0,
    extractor.templates.map((_id) => /*#__PURE__*/
    _jsx("span", { color: "segment-pdf" }, _id,
    templateNamesById[_id]
    )
    )
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "property-info-buttons" }, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      title: status.key !== 'ready' ? 'Cancel' : 'Train',
      className: `btn service-request-button find-suggestions ${status.key}`,
      onClick: onFindSuggestionButtonClicked }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, ixmessages[status.key]), " ", formatData(status.data)
    ), /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "btn suggestion-filters",
      onClick: () => setFiltersOpen(true) }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "filter" }), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Show Filters")
    )
    )
    ), /*#__PURE__*/
    _jsx(TrainingHealthDashboard, { stats: stats })
    ), /*#__PURE__*/
    React.createElement("table", _extends({}, getTableProps(), { className: "table sticky" }), /*#__PURE__*/
    _jsx("thead", { className: "header" }, void 0,
    headerGroups.map((headerGroup) => /*#__PURE__*/
    React.createElement("tr", headerGroup.getHeaderGroupProps(),
    headerGroup.headers.map((column) => {
      const className =
      column.className + (filters.find((f) => f.id === column.id) ? ' filtered' : '');
      return /*#__PURE__*/(
        React.createElement("th", column.getHeaderProps({ className }),
        column.render('Header'),
        column.canFilter && column.Filter && column.render('Filter')
        ));

    })
    )
    )
    ), /*#__PURE__*/
    React.createElement("tbody", getTableBodyProps(),
    page.map((row) => {
      prepareRow(row);
      return /*#__PURE__*/(
        React.createElement("tr", row.getRowProps(),
        row.cells.map((cell) => /*#__PURE__*/
        React.createElement("td", cell.getCellProps({ className: cell.column.className }),
        cell.render('Cell')
        )
        )
        ));

    })
    )
    ), /*#__PURE__*/
    _jsx(Pagination, {
      resetActivePage: resetActivePage,
      onPageChange: gotoPage,
      onPageSizeChange: setPageSize,
      totalPages: totalPages }
    ), /*#__PURE__*/
    _jsx(SuggestionAcceptanceModal, {
      isOpen: acceptingSuggestion,
      propertyType: reviewedProperty.type,
      languages: languages,
      onClose: () => {
        toggleAllRowsSelected(false);
        setAcceptingSuggestion(false);
      },
      onAccept: async (allLanguages) => acceptSuggestion(allLanguages) }
    ), /*#__PURE__*/
    _jsx(CancelFindingSuggestionModal, {
      isOpen: openCancelFindingSuggestions,
      onClose: () => setOpenCancelFindingSuggestions(false),
      onAccept: async () => _cancelFindingSuggestions() }
    )
    ),
    Boolean(selectedFlatRows.length) && /*#__PURE__*/
    _jsx(PDFSidePanel, {
      open: sidePanelOpened,
      closeSidePanel: closePDFSidePanel,
      handleSave: handlePDFSidePanelSave,
      entitySuggestion: selectedFlatRows[0].original }
    )

    ));

};

export const EntitySuggestions = connect(mapStateToProps)(EntitySuggestionsComponent);